module.exports = __webpack_public_path__ + "static/RPB-d7ff9cdc177324e9c085c86f1e5e994d.png";